import { IDialogAction } from './IDialogAction';
import { DialogState } from '../models/DialogState';

export const INITIALIZE = 'INITIALIZE';

export class InitializeAction implements IDialogAction {
    public readonly type = INITIALIZE;
    public constructor(public payload: any) {}
    public reducer(state: DialogState): DialogState {        
        this.payload.tabs.forEach((t: any) => {
            state.feed.tabs.push({
                id: t.i,
                name: t.n,
                notification: t.c,
                sequence: t.s,
                searchable: t.is,
                emptyText: t.et,
                icon: {
                    id: 0,
                    src: t.iu
                },
                bookmarkRequired: t.br,
                addedMessages: []
            });
        });
        state.feed.enableMessageSnippets = this.payload.enableMessageSnippets;
        state.feed.enableLinkPreview = this.payload.enableLinkPreview;
        state.feed.currentTabId = state.feed.tabs[0].id;
        state.feed.ready = true;
        return state;
    }
}

export const InitializeActionTypeMapping = {
    [INITIALIZE]: InitializeAction
};